import { Component, OnInit, AfterViewChecked } from '@angular/core';

import { NgxUiLoaderService } from 'ngx-ui-loader';
import { Router, ActivatedRoute } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';

import { AccountService } from 'app/account/account.service';
import { BaseService } from 'app/_services/base.service';
import { BuyerService } from '../_services/buyer.service';
import { BuyerVisaoGeralDetalheService } from './detalhe.service';
import { GeneralService } from 'app/_services/general.service';
import { NotificationService } from 'app/_services/notification.service';

import { Globals } from 'app/_models/globals';
import { RoutingState } from 'app/_utils/routingstate';
import { Transportadora } from 'app/_models/transportadora';
import { CrispTemplateEnum } from 'app/_models/crisp';
import { User } from 'app/_models/user';
import { StatusIdEnum } from 'app/_models/statusId';
import { BuyerOrdersPutResponseModel } from './_models/buyerOrdersPutResponseModel';
import { ApiResponseModel } from 'app/_models/apiResponseModel';
import { SettingsService } from 'app/_services/settings.service';
import { UserService } from 'app/_services/user.service';

declare const copyToClipboard: any;
declare const isEmpty: any;

@Component({
    selector: 'app-visaogeraldetalhe', templateUrl: './detalhe.component.html', styleUrls: ['./detalhe.component.scss'],
    standalone: false
})
export class BuyerVisaoGeralDetalheComponent implements OnInit {
    hasAguardandoConfirmacao: boolean = false;
    transaction_id: number;
    agrupamento: any;
    deliveryTimes: any[];
    directWhatsappIntegration: boolean = false;
    feriados: string[];
    formasPagamento: any = {};
    isOnError: boolean;
    quotation: any;
    nome_usuario: any;
    transportadoras: Transportadora[] = [];

    constructor(public accountService: AccountService, private userService: UserService, private baseService: BaseService, private buyerService: BuyerService, private buyerVisaoGeralDetalheService: BuyerVisaoGeralDetalheService,
        private generalService: GeneralService, private notificationService: NotificationService, private globals: Globals, private route: ActivatedRoute, private ngxLoader: NgxUiLoaderService,
        private router: Router, private routingState: RoutingState, private translate: TranslateService, public settingService: SettingsService)
    { }

    ngOnInit() {
        this.directWhatsappIntegration = this.generalService.directWhatsappIntegration;

        this.agrupamento = [];
        this.quotation = {};

        var param_id = this.route.snapshot.params.id;
        var isValid = /^\d+$/.test(param_id);
        this.isOnError = !isValid;

        if (isValid)
        {
            this.transaction_id = parseInt(param_id);
            this.verDetalhes(this.transaction_id);
        }
    }

    ngAfterViewChecked()
    {
        // Caso a tela esteja com erro, volta para a home
        if (this.isOnError)
            this.voltar({ corpo: 'buyer.dados-pedido.mensagens.erro.sem-codigo', parametro: '' });
    }

    atualizarPedido(param) {
        this.verDetalhes(param.quotation_id);
    }

    copyGetConfirmation(param: any) {
        const oficina = this.userService.user()?.selectedUser?.current_company_name;
        let urlPartsfy = this.generalService.getPartsfyUrl();
        let urlCotacao = urlPartsfy + '/vendedor/visao-geral/confirmar-pedido/' + param.orderId;
        let veiculo = this.agrupamento.marca + ' - ' + this.agrupamento.veiculo;

        this.ngxLoader.startLoader('loader-principal');

        this.generalService.getCrispTemplate(CrispTemplateEnum.AguardandoConfirmacaoV2).subscribe({
            next: (response: ApiResponseModel<{ message }>) => {
                if (response && response.success) {
                    var text = response.result.message;

                    text = text.replace('{{1}}', `${oficina}`);
                    text = text.replace('{{2}}', `${veiculo}`);
                    text = text.replace('{{3}}', `${urlCotacao}`);

                    copyToClipboard(text);
                    this.notificationService.showSuccessToastr(this.globals.translate('geral.info-geral.mensagens.info-copiada.sucesso'));
                    this.ngxLoader.stopLoader('loader-principal');
                } else {
                    this.notificationService.showErrorToastr(this.globals.translate('geral.info-geral.mensagens.info-copiada.erro'));
                }
            },
            error: () => {
                this.ngxLoader.stopLoader('loader-principal');
            }
        })
    }

    verDetalhes(quotation_id: number) {
        this.ngxLoader.startLoader('loader-principal');

        this.buyerVisaoGeralDetalheService.get(quotation_id).subscribe({
            next: (response: ApiResponseModel<BuyerOrdersPutResponseModel>) => {
                if (response && response.success) {
                    if (response.result.order === null) {
                        this.voltar({ corpo: 'buyer.dados-pedido.mensagens.erro.nao-encontrado', parametro: quotation_id });
                        return;
                    }

                    response.result.order.fotos = response.result.photos;

                    this.agrupamento = response.result.order;
                    this.agrupamento.fotos = response.result.photos;
                    this.deliveryTimes = response.result.deliveryTimes;
                    this.transportadoras = response.result.transportadoras;

                    let holidays = response.result.holidays;
                    this.feriados = holidays.map(h => h.replace('T05:00:00', ''));

                    let formasPagamento = Object.assign([], response.result.paymentTypes);
                    formasPagamento.splice(0, 1);

                    this.formasPagamento = formasPagamento.reduce((acc, item) => ({ ...acc, [item.id]: item.texto }), {});

                    if (!isEmpty(this.agrupamento)) {
                        for (let pedido of this.agrupamento.pedidos) {
                            pedido = this.buyerService.atualizarTotais(pedido);
                            pedido.min_status = Math.min.apply(Math, pedido.pecas.map(p => p.status));
                            pedido.isCashbackCustomizado = pedido.had_cashback && pedido.pecas.some(p => p.desconto_original != p.desconto);
                            pedido.isCashbackPadronizado = pedido.had_cashback && !pedido.isCashbackCustomizado;
                        }

                        this.hasAguardandoConfirmacao = this.agrupamento.pedidos.some(p => p.min_status < StatusIdEnum.Confirmado);
                    }

                    this.buyerService.handleEditionInformationsLoad(this.agrupamento, this.deliveryTimes, this.feriados);
                }

                this.ngxLoader.stopLoader('loader-principal');
            },
            error: error => {
                console.log(error);

                if (error.status === 404) {
                    this.voltar({ corpo: 'buyer.dados-pedido.mensagens.erro.nao-encontrado', parametro: quotation_id });
                    return;
                }

                this.ngxLoader.stopLoader('loader-principal');
            }
        });
    }

    voltar(errorMessage: { corpo: string, parametro: any } | null)
    {
        if (!isEmpty(errorMessage))
        {
            this.translate.get(errorMessage.corpo).subscribe(corpo =>
            {
                this.notificationService.showErrorToastr(corpo.replace("#xxx", "#" + errorMessage.parametro));
            });
        }

        let previousPage = this.buyerService.obterPaginaAnteriorSemaforoVisaoGeral(this.routingState.getHistory());
        this.router.navigate([previousPage]);
    }
}
